import useUrlState from '@ahooksjs/use-url-state';
import { Stack, Tabs } from '@mantine/core';
import { Breadcrumbs, Text, Title } from '@repo/foundations';
import {
	NavBarBreadcrumbWrapper,
	NavBarWrapper,
} from '../../components/SecodaAppShell/SecodaNavBar';
import { BrowseTab } from './BrowseTab';

import { CreateTab } from './CreateTab';

function IntegrationsBrowsePage() {
	const [state, setState] = useUrlState<{ tab: string }>({ tab: 'browse' });

	return (
		<Stack spacing={0}>
			<NavBarWrapper>
				<NavBarBreadcrumbWrapper>
					<Breadcrumbs
						crumbs={[{ title: 'Integrations', href: '/integrations' }]}
					/>
				</NavBarBreadcrumbWrapper>
			</NavBarWrapper>
			<Stack px="2xl">
				<Title size="3xl">Find an integration</Title>
				<Text size="md">
					Browse and connect integrations or create your own integration for the
					community.
				</Text>
				<Tabs
					color="fill/brand/default"
					value={state.tab}
					onTabChange={(value) => setState({ tab: value })}
				>
					<Tabs.List>
						<Tabs.Tab value="browse">Browse</Tabs.Tab>
						<Tabs.Tab value="create">Create</Tabs.Tab>
					</Tabs.List>
				</Tabs>
				{state.tab === 'browse' && <BrowseTab />}
				{state.tab === 'create' && <CreateTab />}
			</Stack>
		</Stack>
	);
}

export default IntegrationsBrowsePage;
